var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableBenchA = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13.53 23.75h3.529v11.875h-1.946a2.5 2.5 0 0 1-2.488-2.746l.905-9.129ZM46.47 23.75h-3.529v11.875h1.946a2.5 2.5 0 0 0 2.488-2.746l-.904-9.129ZM17.059 23.75h25.882v11.875H17.059z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M47.647 23.75H12.353"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M48.824 23.75c0 .656-.527 1.188-1.177 1.188H12.353c-.65 0-1.176-.532-1.176-1.188 0-.656.526-1.188 1.176-1.188h35.294c.65 0 1.177.532 1.177 1.188Z",
  clipRule: "evenodd"
})));
SvgNoTableBenchA.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableBenchA);
export default ForwardRef;